import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getLanguageDisplayName } from '../product-details/utils';
import { LanguageSelectionProps } from './types';

export const LanguageSelection: React.FC<LanguageSelectionProps> = ({
  targetLanguage,
  availableTargets,
  onLanguageChange,
  disabled = false
}) => {
  const { t } = useTranslation();

  return (
    <TextField
      select
      label={t('translation.targetLanguage')}
      value={targetLanguage}
      onChange={(e) => onLanguageChange(e.target.value)}
      size="small"
      disabled={disabled || availableTargets.length === 0}
      error={availableTargets.length === 0}
      helperText={availableTargets.length === 0 ? t('translation.noTargetLanguages') : ''}
      sx={{ minWidth: 240 }}
    >
      {availableTargets.map((code) => (
        <MenuItem key={code} value={code}>
          {getLanguageDisplayName(code)}
        </MenuItem>
      ))}
    </TextField>
  );
};
